import CryptoJS from 'crypto-js';

export function generateChatId(user1Id, user2Id) {
    const combinedIds = [user1Id, user2Id].sort().join('_');
    const fullHash = CryptoJS.SHA256(combinedIds).toString(CryptoJS.enc.Base64);
    
    return fullHash.replace(/[^a-zA-Z0-9]/g, '')
}